export const PaymentRouting = [
  {
    path: "/purchase/payment/list",
    name: "purchase-payment-list",
    meta: { title: "采购付款申请" },
    notice: { type: "purchase_payment_apply_examine", hasNotice: false },
    component: () =>
      import(/* webpackChunkName: "purchase-payment" */ "@/views/purchase/payment/list/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/payment/create",
    name: "purchase-payment-create",
    meta: { title: "新增采购付款申请",comName:'purchasePaymentFormCreate' },
    component: () =>
      import(/* webpackChunkName: "purchase-payment" */ "@/views/purchase/payment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/payment/edit/:id",
    name: "purchase-payment-edit",
    meta: { title: "编辑采购付款申请",comName:'purchasePaymentFormCreate' },
    component: () =>
      import(/* webpackChunkName: "purchase-payment" */ "@/views/purchase/payment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/payment/detail/:id",
    name: "purchase-payment-detail",
    meta: { title: "采购付款申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-payment" */ "@/views/purchase/payment/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/payment/flowPrint/:id",
    name: "purchase-payment-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-payment" */ "@/views/purchase/payment/flow-print/index.vue"
      ),
  },
];
